const em1eData = {
  slug: "em1-e",
  name: "Honda EM1 e:",

  hero: {
    shortDescription:
      "Skuter listrik urban Honda dengan desain kompak, teknologi baterai swappable, dan performa ramah lingkungan untuk mobilitas harian",

    variants: [
      {
        key: "innovative-white",
        label: "Innovative",
        fullName: "Honda EM1 e: Innovative White",
        startPrice: 40000000,
      },
      {
        key: "intelligent-black",
        label: "Intelligent",
        fullName: "Honda EM1 e: Intelligent Matte Black",
        startPrice: 40000000,
      },
      {
        key: "smart-red",
        label: "Smart",
        fullName: "Honda EM1 e: Smart Red",
        startPrice: 40500000,
      },
      {
        key: "excellent-silver",
        label: "Excellent",
        fullName: "Honda EM1 e: Excellent Matte Silver",
        startPrice: 40500000,
      },
    ],

    slides: [
      {
        variantKey: "innovative-white",
        image: "/assets/motor/produk/em1e/EM1-Innovative-White.webp",
        specs: {
          engine: "Motor Listrik (In-Wheel Brushless Motor)",
          power: "1,7 kW (Peak Power)",
          smartKey: false,
        },
      },
      {
        variantKey: "intelligent-black",
        image: "/assets/motor/produk/em1e/EM1-Intelligent-Matte-Black.webp",
        specs: {
          engine: "Motor Listrik (In-Wheel Brushless Motor)",
          power: "1,7 kW (Peak Power)",
          smartKey: false,
        },
      },
      {
        variantKey: "smart-red",
        image: "/assets/motor/produk/em1e/EM1-Smart-Red.webp",
        specs: {
          engine: "Motor Listrik (In-Wheel Brushless Motor)",
          power: "1,7 kW (Peak Power)",
          smartKey: false,
        },
      },
      {
        variantKey: "excellent-silver",
        image: "/assets/motor/produk/em1e/EM1-Excellent-Matte-Silver.webp",
        specs: {
          engine: "Motor Listrik (In-Wheel Brushless Motor)",
          power: "1,7 kW (Peak Power)",
          smartKey: false,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda EM1 e: merupakan skuter listrik kompak yang dirancang untuk mobilitas urban dengan teknologi baterai swappable Honda Mobile Power Pack e: dan performa responsif tanpa emisi gas buang.",
      },
      {
        type: "paragraph",
        text:
          "Skuter ini menawarkan pengalaman berkendara senyap dan efisien untuk penggunaan harian di kota, serta kemudahan penggantian baterai di stasiun swap yang tersedia.",
      },
      {
        type: "heading",
        text: "Desain Modern & Compact",
      },
      {
        type: "paragraph",
        text:
          "Tampilan EM1 e: didesain modern dengan lampu LED, panel meter digital, dan dek kaki yang luas untuk kenyamanan berkendara.",
      },
      {
        type: "heading",
        text: "Teknologi Baterai Honda",
      },
      {
        type: "paragraph",
        text:
          "Honda Mobile Power Pack e: memberikan fleksibilitas pengisian baterai dan penggantian cepat di titik swap, mendukung mobilitas harian dengan efisiensi tinggi.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Motor", "Motor Listrik (In-Wheel Brushless Motor)"],
      ["Daya Maksimum", "1,7 kW"],
      ["Torsi Maksimum", "90 Nm"],
      ["Sistem Penggerak", "Drive Belt"],
    ],

    rangka: [
      ["Tipe Rangka", "Underbone"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Suspensi Belakang Ganda"],
      ["Rem Depan", "Cakram Hidrolik"],
      ["Rem Belakang", "Tromol"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.795 x 680 x 1.080 mm"],
      ["Tinggi Jok", "740 mm"],
      ["Jarak Sumbu Roda", "1.300 mm"],
      ["Berat", "94 kg"],
    ],

    kapasitas: [
      ["Tipe Baterai", "Honda Mobile Power Pack e:"],
      ["Kapasitas Baterai", "±29,4 Ah"],
    ],

    kelistrikan: [
      ["Sistem Starter", "Electric"],
      ["Panel Meter", "Full Digital"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda EM1 e:",
    items: [
      {
        title: "Skuter Listrik Kompak",
        desc:
          "Desain kompak dan ringan ideal untuk mobilitas harian di perkotaan.",
      },
      {
        title: "Honda Mobile Power Pack e:",
        desc:
          "Teknologi baterai swap praktis yang memudahkan pengisian dan pemakaian.",
      },
      {
        title: "Panel Meter Digital",
        desc:
          "Panel meter digital modern dengan indikator baterai dan kecepatan yang jelas.",
      },
      {
        title: "Full LED Lighting System",
        desc:
          "Lampu depan dan belakang LED memberikan visibilitas optimal.",
      },
      {
        title: "Rem Cakram Depan",
        desc:
          "Rem cakram depan untuk pengereman yang responsif dan aman.",
      },
      {
        title: "Ban Tubeless",
        desc:
          "Ban tubeless yang siap pakai untuk berbagai kondisi jalan.",
      },
    ],
  },
};

export default em1eData;
